import cookies from './cookies';
import { encode, decode } from '../../core/src/transformers/base64';

// Limits to 25 chars, removes spaces and matches one or more characters that are not in the OWASP Top 10 vulnerabilities
export const ACCESS_CODE_FORMATTER = /^(?!\s)(?=.{1,25}$)[^<>'"\\/;()= ]+$/i;

const COOKIE_PREFIX = 'Ravnur-ac__';

class AccessCode {
  private constructCookieName(id: string) {
    return COOKIE_PREFIX + id;
  }

  public setAccessCode(id: string, code: string) {
    const name = this.constructCookieName(id);
    const encodedCode = encode(code);
    const expires = new Date(Date.now() + 86400e3); // +1 day from now

    cookies.setCookie(name, encodedCode, { expires });
  }

  public getAccessCode(id: string) {
    const name = this.constructCookieName(id);
    const code = cookies.getCookie(name);

    return code ? decode(code) : '';
  }

  public removeAccessCode(id: string) {
    const name = this.constructCookieName(id);

    return cookies.deleteCookie(name);
  }
}

export default new AccessCode();
